import React from "react";
import { useForceDarkTheme } from "../hooks/useForceDarkTheme";

export default function TermsOfService() {
  useForceDarkTheme();
  return (
    <div className="min-h-screen bg-black text-gray-200 px-6 py-16">
      <div className="max-w-3xl mx-auto space-y-6">
        <h1 className="text-4xl font-bold text-white">Términos y Condiciones de Servicio</h1>
        <p className="text-sm text-gray-400">Última actualización: 24 de febrero de 2026</p>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">1. Aceptación</h2>
          <p>
            Al usar el CRM interno de JG Models y los servicios asociados (<a className="text-pink-400" href="https://jgmodels.com">jgmodels.com</a>),
            aceptas estos Términos. Si no estás de acuerdo, no uses la plataforma.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">2. Uso permitido</h2>
          <p>El acceso al CRM está restringido al personal autorizado de JG Models (CEO, administrativo, asistente, chatters
            y modelos representadas). Cada usuario es responsable de mantener la confidencialidad de sus credenciales.</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>No compartir cuentas con terceros.</li>
            <li>No extraer ni divulgar información confidencial de la agencia, modelos o clientes.</li>
            <li>No usar el CRM para fines ilegales, fraudulentos o contrarios a las políticas de plataformas
              externas como OnlyFans, Instagram, MYM Fans o PornHub.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">3. Integraciones con terceros</h2>
          <p>
            El CRM se integra con APIs oficiales de Meta (Instagram Graph API) y otros servicios. El uso de estas
            integraciones está sujeto adicionalmente a los términos de cada proveedor:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li><a className="text-pink-400" href="https://www.facebook.com/legal/terms">Términos de Meta Platforms</a></li>
            <li><a className="text-pink-400" href="https://help.instagram.com/581066165581870">Términos de Instagram</a></li>
            <li><a className="text-pink-400" href="https://developers.facebook.com/terms/">Política de Plataforma de Meta</a></li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">4. Modelos y consentimiento</h2>
          <p>
            Las modelos representadas autorizan expresamente a JG Models para gestionar y auditar sus cuentas de
            redes sociales conectadas voluntariamente al CRM. Pueden revocar esta autorización en cualquier momento
            escribiendo a <a className="text-pink-400" href="mailto:privacy@jgmodels.com">privacy@jgmodels.com</a>.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">5. Propiedad intelectual</h2>
          <p>
            Todo el contenido del CRM (código, diseño, datos operativos) es propiedad de JG Models. Queda prohibida
            la reproducción, distribución o modificación sin autorización escrita.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">6. Limitación de responsabilidad</h2>
          <p>
            JG Models no será responsable por interrupciones del servicio, pérdida de datos o fallos en
            integraciones de terceros (Meta, OnlyFans, MYM Fans, etc.) que estén fuera de nuestro control. Hacemos
            todo el esfuerzo razonable para mantener la plataforma operativa y segura.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">7. Suspensión y terminación</h2>
          <p>
            Nos reservamos el derecho de suspender el acceso de cualquier usuario que incumpla estos Términos o
            que ponga en riesgo la operación o reputación de la agencia.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">8. Cambios a estos Términos</h2>
          <p>
            JG Models puede actualizar estos Términos en cualquier momento. Notificaremos cambios sustanciales con
            al menos 7 días de anticipación a los usuarios activos.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-2xl font-semibold text-white">9. Contacto</h2>
          <p>
            JG Models — <a className="text-pink-400" href="mailto:contacto@jgmodels.com">contacto@jgmodels.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
